import React, { useState, useEffect } from 'react';
import { Picker } from 'antd-mobile';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../api';
import './ZoneSelector.css';
import { useZone } from '../contexts/ZoneContext';

/**
 * 区域选择器组件
 * 显示当前区域并允许切换区域
 * 
 * @returns {JSX.Element} 区域选择器组件
 */
const ZoneSelector = () => {
  const navigate = useNavigate();
  const { zone = 'zone1' } = useParams(); // 获取当前区域参数
  const { currentZone, updateZone } = useZone(); // 从上下文获取当前区域和更新方法
  const [visible, setVisible] = useState(false);
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // 优先使用URL参数中的区域，如果没有则使用上下文中的区域
  const activeZone = zone || currentZone;
  
  // 同步URL参数到上下文
  useEffect(() => {
    if (zone && zone !== currentZone) {
      updateZone(zone);
    }
  }, [zone, currentZone, updateZone]);
  
  // 从API获取区域列表
  useEffect(() => {
    const fetchZones = async () => {
      try {
        setLoading(true);
        const response = await api.system.getAllZones();
        
        if (response.status === 'success' && response.data && response.data.zones) {
          // 将API返回的区域数据转换为Picker需要的格式
          const formattedZones = response.data.zones.map(z => ({
            label: z.name,
            value: z.code
          }));
          setZones(formattedZones);
        } else {
          // 如果API请求失败，使用默认区域列表
          setZones([
            { label: '北京', value: 'beijing' },
            { label: '上海', value: 'shanghai' },
            { label: '区域1', value: 'zone1' },
            { label: '区域2', value: 'zone2' }
          ]);
          console.error('获取区域列表失败', response);
        }
      } catch (err) {
        console.error('获取区域列表失败:', err);
        // 出错时使用默认区域列表
        setZones([
          { label: '北京', value: 'beijing' },
          { label: '上海', value: 'shanghai' },
          { label: '区域1', value: 'zone1' },
          { label: '区域2', value: 'zone2' }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchZones();
  }, []);

  const handleZoneChange = (value) => {
    if (value && value.length > 0) {
      const newZone = value[0];
      // 更新上下文中的区域
      updateZone(newZone);
      
      // 切换到相同页面的不同区域
      const currentPath = window.location.pathname;
      const newPath = currentPath.replace(`/badminton/${zone}`, `/badminton/${newZone}`);
      navigate(newPath);
    }
  };

  // 获取当前区域的显示名称
  const getCurrentZoneName = () => {
    const currentZone = zones.find(z => z.value === activeZone);
    return currentZone ? currentZone.label : (loading ? '加载中...' : '未知区域');
  };

  return (
    <div className="zone-selector">
      <div className="zone-selector-label">当前区域:</div>
      <div 
        className="zone-selector-value"
        onClick={() => setVisible(true)}
      >
        {getCurrentZoneName()}
      </div>
      <Picker
        columns={[zones]}
        visible={visible}
        onClose={() => setVisible(false)}
        value={[activeZone]}
        onConfirm={handleZoneChange}
      />
      <button 
        className="back-to-zone-list" 
        onClick={() => navigate('/badminton')}
      >
        返回区域列表
      </button>
    </div>
  );
};

export default ZoneSelector; 